// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import pdiscEntity from './entities/pdisc.json';
import pdiscMenu from '../pages/pdisc/menu.json';
import pdiscFullForm from '../pages/pdisc/forms/full.json';
import pdiscContextForm from '../pages/pdisc/forms/context.json';
import pdiscTableView from '../pages/pdisc/views/table.json';
import pdiscStagesView from '../pages/pdisc/views/stages.json';
import pdiscCardsView from '../pages/pdisc/views/cards.json';
import pdiscInlineView from '../pages/pdisc/views/inline.json';
import pdiscBacklogView from '../pages/pdisc/views/backlog.json';
import pdiscSplitView from '../pages/pdisc/views/split.json';
import pdiscCalendarView from '../pages/pdisc/views/calendar.json';
import pdiscDashboardView from '../pages/pdisc/views/dashboard.json';

/** Тип запису «Обговорення» зі сторінками пакета: меню, форми та подання з pages/pdisc/. */
export const pdiscDefinition: IRecordTypeDefinition = {
  ...pdiscEntity,
  views: assembleViewSet({
      table: pdiscTableView,
      stages: pdiscStagesView,
      cards: pdiscCardsView,
      inline: pdiscInlineView,
      backlog: pdiscBacklogView,
      split: pdiscSplitView,
      calendar: pdiscCalendarView,
      dashboard: pdiscDashboardView,
  }),
  form: pdiscFullForm,
  forms: { full: pdiscFullForm, context: pdiscContextForm },
  menu: pdiscMenu,
} as IRecordTypeDefinition;
